import { bodyPart } from '../../../../constants/bodyPart';
import { gameImportType } from '../../../../constants/gameImportType';
import { actorType } from '../../../../constants/actorType';
import { Config as movementConfig } from './objectData/movementConfig';

export const familyAssetConfig = {
  NAME: 'FAMILY',
  ACTORTYPE: actorType.OBJECT,
  DATA: [movementConfig],
  TYPE: gameImportType.SPRITESHEET,
  SPRITESHEET_FOLDER: 'family',
  SPRITESHEET_NAME: 'Family-Sprite-Map-',
  CHATBUBBLECOORDINATES: { x: -0.3, y: -0.2 },
  INVENTORY: {
    [bodyPart.MOUTH]: [],
    [bodyPart.NECK]: [],
  },
  AUDIO: {},
  SCALE: 0.6,
  HEIGHT: 800,
  WIDTH: 800,
};
